import { render, staticRenderFns } from "./PosDiscount.vue?vue&type=template&id=4e5c2b6b&scoped=true&"
import script from "./PosDiscount.vue?vue&type=script&lang=js&"
export * from "./PosDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c2b6b",
  null
  
)

export default component.exports